function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.75 14.25v9m0-1.5h16.5a3 3 0 00-3-3H10.5a3 3 0 00-3-3H.75m6 3h3.75m9.74-.742a7.475 7.475 0 00-2.022-13.059l1.853-3.17a.679.679 0 000-.687.707.707 0 00-.611-.342h-7.42a.707.707 0 00-.609.342.679.679 0 000 .687l1.853 3.17A7.477 7.477 0 008.25 12",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7 13.844a2.224 2.224 0 001.858.875c1.139 0 2.063-.693 2.063-1.547s-.924-1.546-2.063-1.546-2.058-.693-2.058-1.548.924-1.547 2.062-1.547a2.221 2.221 0 011.858.875m-1.858 5.313v1.031m0-8.25v1.031",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgCashPaymentBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgCashPaymentBag;